import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExamAttemptExpiredModal = ({
  onView
}) => /*#__PURE__*/_jsxs(Modal, {
  use: "success",
  children: [/*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onView
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.expired.title"
      })
    })]
  }), /*#__PURE__*/_jsx(DialogBody, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.expired.body"
    })
  }), /*#__PURE__*/_jsx(DialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(Button, {
      onClick: onView,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.expired.cta"
      })
    })
  })]
});
export default ExamAttemptExpiredModal;